export default __webpack_public_path__ + "static/media/lynk_sketch.ac42673b.jpg";